import { createSlice } from '@reduxjs/toolkit';

export const AppSlice = createSlice({
    name: "app",
    initialState: {
        orderDashboard:{
          filteredTaskId:0
        },
        title:'',
        orderType:'IN-PROGRESS',
        selectedProductOrderForStockOutReqId:'',
        stockOrderObj:{},
        supplierTypeId:0,
        supplierId:'', // This will hold the selected supplier for stock order
        urlParam: '',
        exposedSubURL:["partnerinventory", "inventory", "customer-catalogue", "partner-inventory-with-prices"],
        mode:'customer',
        urlProductCode:'',
      },
    reducers: {
      setFilteredTaskId : (state, action) =>{
        state.orderDashboard.filteredTaskId=action.payload;
      },
      setTitle : (state, action) =>{
        state.title = action.payload;
      },
      setOrderType : (state, action) =>{
        state.orderType=action.payload;
      },
      setSelectedProductOrderForStockOutReqId : (state, action) =>{
        state.selectedProductOrderForStockOutReqId = action.payload;
      },
      setStockOrderObj : (state, action) =>{
        state.stockOrderObj = action.payload; 
      },
      setSupplierId : (state, action) =>{
        state.supplierId = action.payload;
      },
      setUrlParam : (state, action) =>{
        state.urlParam = action.payload;
      },
      setMode : (state, action) =>{
        state.mode = action.payload;
      },
      setUrlProductCode:  (state, action) => {
        state.urlProductCode = action.payload;
      },
      setSupplierTypeId: (state, action) => {
        state.supplierTypeId = action.payload;
      }
    }
});
export const {setSupplierTypeId, setUrlProductCode, setMode, setUrlParam, setSupplierId, setStockOrderObj, setSelectedProductOrderForStockOutReqId, setFilteredTaskId,setTitle,setOrderType } = AppSlice.actions;
export default AppSlice.reducer;